<template>
  <el-select
    v-model="purchasesOrderModel"
    @change="purchasesOrderChanged"
    autocomplete="new-password"
    :placeholder="$t('COMMON.PURCHASES_ORDER')"
    :filterable="filterable"
    :multiple="multiple"
    :disabled="disabled"
    remote
    :remote-method="getPurchasesOrders"
    :loading="loading"
  >
    <el-option
      v-if="showAll"
      :value="null"
      :label="$t('COMMON.PURCHASES_ORDER')"
    >
    </el-option>
    <el-option v-if="allowNone" :value="null" :label="$t('COMMON.NONE')">
    </el-option>
    <el-option
      v-for="purchasesOrder in purchasesOrders"
      :key="purchasesOrder.id"
      :value="purchasesOrder.id"
      :label="`${purchasesOrder.code}`"
    >
    </el-option>
  </el-select>
</template>

<script>
import { Option, Select } from "element-ui";

export default {
  name: "purchases-order-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
      description: "Disable the input",
    },
    showAll: {
      type: Boolean,
      default: true,
      description: "Show the option all",
    },
    allowNone: {
      type: Boolean,
      default: false,
      description: "Show the option none",
    },
    filterable: {
      type: Boolean,
      default: true,
      description: "Can filter",
    },
    multiple: {
      type: Boolean,
      default: false,
      description: "Can filter",
    },
    purchasesOrder: {
      type: String,
      default: null,
      description: "PurchasesOrder id",
    },
    filterReseller: {
      type: String,
      default: null,
      description: "Reseller id",
    },
    filterOrganization: {
      type: String,
      default: null,
      description: "Organization id",
    },
    filterStatus: {
      type: String,
      default: null,
      description: "PurchasesOrder status",
    },
  },

  data() {
    return {
      purchasesOrderModel: this.purchasesOrder,
      purchasesOrders: {},
    };
  },

  setup() {},

  created() {
    this.getPurchasesOrders(null, this.purchasesOrder);
  },

  methods: {
    async getPurchasesOrders(query = null, id = null) {
      try {
        this.loading = true;
        let params = {
          sort: "-updated_at",
          filter: {
            ...(query ? { code: query } : {}),
            ...(id ? { with_ids: id } : {}),
          },
          page: {
            number: 1,
            size: 10,
          },
        };

        if (this.filterOrganization) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: this.filterOrganization,
            },
          };
        }
        if (this.filterReseller) {
          params = {
            ...params,
            filter: { ...params.filter, reseller: this.filterReseller },
          };
        }
        if (this.filterOrganization) {
          params = {
            ...params,
            filter: { ...params.filter, organization: this.filterOrganization },
          };
        }
        if (this.filterStatus) {
          params = {
            ...params,
            filter: { ...params.filter, status: this.filterStatus },
          };
        }

        await this.$store.dispatch("purchasesOrders/list", params);
        const purchasesOrdersArr = await this.$store.getters[
          "purchasesOrders/list"
        ];
        this.purchasesOrders = {};
        purchasesOrdersArr.forEach((purchasesOrder) => {
          this.purchasesOrders[purchasesOrder.id] = purchasesOrder;
        });
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    purchasesOrderChanged(purchasesOrderId) {
      const puchaseOrder = Object.values(this.purchasesOrders).find(
        (item) => item.id === purchasesOrderId
      );
      this.$emit("purchasesOrderChanged", purchasesOrderId, puchaseOrder);
    },
  },

  watch: {
    purchasesOrder(purchasesOrder) {
      if (purchasesOrder) {
        this.purchasesOrderModel = purchasesOrder;
        if (purchasesOrder !== this.purchasesOrderModel) {
          this.getPurchasesOrders(null, purchasesOrder);
        }
      } else {
        this.purchasesOrderModel = null;
      }
    },
    filterOrganization(filterOrganization) {
      this.getPurchasesOrders();
    },
    filterReseller() {
      this.getPurchasesOrders();
    },
    filterStatus() {
      this.getPurchasesOrders();
    },
  },
};
</script>
